import { lazy } from 'react';

/** Route-level code splitting: keep shell imports in App.tsx, lazy-load page modules. */
export const Homepage = lazy(() => import('./pages/Homepage'));
export const TeamPage = lazy(() => import('./pages/TeamPage'));
export const ProductLandingPage = lazy(() => import('./pages/ProductLandingPage'));
export const ServicesPage = lazy(() => import('./pages/ServicesPage'));
export const BlogListPage = lazy(() => import('./pages/BlogListPage'));
export const BlogPostPage = lazy(() => import('./pages/BlogPostPage'));
export const LoginPage = lazy(() => import('./pages/LoginPage'));
export const RegisterPage = lazy(() => import('./pages/RegisterPage'));
export const ResetPasswordPage = lazy(() => import('./pages/ResetPasswordPage'));
export const TermsPage = lazy(() => import('./pages/TermsPage'));
export const AcceptTermsPage = lazy(() => import('./pages/AcceptTermsPage'));
export const BrandsDashboard = lazy(() => import('./pages/BrandsDashboard'));
export const BrandDetailPage = lazy(() => import('./pages/BrandDetailPage'));
export const BrandSettingsPage = lazy(() => import('./pages/BrandSettingsPage'));
export const MySubredditsPage = lazy(() => import('./pages/MySubredditsPage'));
export const InboxPage = lazy(() => import('./pages/InboxPage'));
export const LeadsPage = lazy(() => import('./pages/leads/LeadsPage'));
export const AIReplyGeneratorPage = lazy(() => import('./pages/AIReplyGeneratorPage'));
export const LLMGeoAnalysisPage = lazy(() => import('./pages/LLMGeoAnalysisPage'));
export const LLMGeoAnalysisProgressPage = lazy(() => import('./pages/LLMGeoAnalysisProgressPage'));
export const LLMGeoAnalysisReportPage = lazy(() => import('./pages/LLMGeoAnalysisReportPage'));
export const CitationAuthorityPage = lazy(() => import('./pages/CitationAuthorityPage'));
export const CitationAuthorityReportPage = lazy(() => import('./pages/CitationAuthorityReportPage'));
export const CommunityEngagementPage = lazy(() => import('./pages/CommunityEngagementPage'));
export const CommunityEngagementReportPage = lazy(() => import('./pages/CommunityEngagementReportPage'));
export const StructuredDataPage = lazy(() => import('./pages/StructuredDataPage'));
export const StructuredDataReportPage = lazy(() => import('./pages/StructuredDataReportPage'));
export const CrossPlatformPage = lazy(() => import('./pages/CrossPlatformPage'));
export const CrossPlatformReportPage = lazy(() => import('./pages/CrossPlatformReportPage'));
export const SemanticOptimizationPage = lazy(() => import('./pages/SemanticOptimizationPage'));
export const SemanticOptimizationReportPage = lazy(() => import('./pages/SemanticOptimizationReportPage'));
export const CompetitorAnalysisListPage = lazy(() => import('./pages/CompetitorAnalysisListPage'));
export const CompetitorAnalysisPage = lazy(() => import('./pages/CompetitorAnalysisPage'));
export const CompetitorAnalysisDashboardPage = lazy(() => import('./pages/CompetitorAnalysisDashboardPage'));

export const AdminDashboard = lazy(() => import('./pages/admin/AdminDashboard'));
export const AdminUsersPage = lazy(() => import('./pages/admin/AdminUsersPage'));
export const AdminSessionsPage = lazy(() => import('./pages/admin/AdminSessionsPage'));
export const FeatureMatrixPage = lazy(() => import('./pages/admin/FeatureMatrixPage'));
export const AICreditUsagePage = lazy(() => import('./pages/admin/AICreditUsagePage'));
export const CompetitorAnalysisSettingsPage = lazy(() => import('./pages/admin/CompetitorAnalysisSettingsPage'));
export const EngagementTrackingPage = lazy(() => import('./pages/admin/EngagementTrackingPage'));
export const WatiTemplatesPage = lazy(() => import('./pages/admin/WatiTemplatesPage'));
export const RedditGenericScraperPage = lazy(() => import('./pages/admin/RedditGenericScraperPage'));
export const WhatsAppConfigPage = lazy(() => import('./pages/admin/WhatsAppConfigPage'));
export const CreditManagementPage = lazy(() => import('./pages/admin/CreditManagementPage'));
export const PricingPlansPage = lazy(() => import('./pages/admin/PricingPlansPage'));
export const ActionPricingPage = lazy(() => import('./pages/admin/ActionPricingPage'));
export const SupervisorsPage = lazy(() => import('./pages/admin/SupervisorsPage'));

export const SupervisorDashboardPage = lazy(() => import('./pages/supervisor/SupervisorDashboardPage'));
export const CreditDashboardPage = lazy(() => import('./pages/CreditDashboardPage'));
export const NotificationSettingsPage = lazy(() => import('./pages/NotificationSettingsPage'));
export const MCPSettingsPage = lazy(() => import('./pages/MCPSettingsPage'));

export const CmsLoginPage = lazy(() => import('./cms/pages/CmsLoginPage'));
export const CmsDashboard = lazy(() => import('./cms/pages/CmsDashboard'));
export const BlogPostsPage = lazy(() => import('./cms/pages/BlogPostsPage'));
export const BlogPostEditorPage = lazy(() => import('./cms/pages/BlogPostEditorPage'));
export const MediaLibraryPage = lazy(() => import('./cms/pages/MediaLibraryPage'));
export const TagManagementPage = lazy(() => import('./cms/pages/TagManagementPage'));
export const SiteNavigationPage = lazy(() => import('./cms/pages/SiteNavigationPage'));
export const ContactFormPage = lazy(() => import('./cms/pages/ContactFormPage'));
export const FaqsPage = lazy(() => import('./cms/pages/FaqsPage'));
export const FaqEditorPage = lazy(() => import('./cms/pages/FaqEditorPage'));
export const HeroesPage = lazy(() => import('./cms/pages/HeroesPage'));
export const HeroEditorPage = lazy(() => import('./cms/pages/HeroEditorPage'));
export const TeamMembersPage = lazy(() => import('./cms/pages/TeamMembersPage'));
export const TeamMemberEditorPage = lazy(() => import('./cms/pages/TeamMemberEditorPage'));
export const CaseStudiesPage = lazy(() => import('./cms/pages/CaseStudiesPage'));
export const CaseStudyEditorPage = lazy(() => import('./cms/pages/CaseStudyEditorPage'));
export const HomepageSectionsPage = lazy(() => import('./cms/pages/HomepageSectionsPage'));
export const ServiceSectionsPage = lazy(() => import('./cms/pages/ServiceSectionsPage'));
export const ProductSectionsPage = lazy(() => import('./cms/pages/ProductSectionsPage'));
export const CTASectionsPage = lazy(() => import('./cms/pages/CTASectionsPage'));
export const ContactDetailsPage = lazy(() => import('./cms/pages/ContactDetailsPage'));
export const SEOManagementPage = lazy(() => import('./cms/pages/SEOManagementPage'));
export const LandingPageContentPage = lazy(() => import('./cms/pages/LandingPageContentPage'));
export const TestFirebase = lazy(() => import('./cms/pages/TestFirebase'));
export const FirebaseSetupTester = lazy(() => import('./cms/components/FirebaseSetupTester'));
export const FirebaseConfigChecker = lazy(() => import('./components/common/FirebaseConfigChecker'));
